/* ============================================================================
   SYMBOLES — catalogo de formas para el cliente (F5)
   ----------------------------------------------------------------------------
   La pestana « Formes » llevaba desde el principio un « Bientôt disponible ».
   Aqui estan las formas de verdad.

   POR QUE PATHS Y NO IMAGENES. Un icono en PNG se ve bien en pantalla y sale
   pixelado al ampliarlo a 300 DPI — un corazon de 8 cm impreso desde un icono
   de 64 px es un borde dentado. Un path es geometria: se rellena a la
   resolucion que haga falta y sale igual de limpio a 2 cm que a 40. Ademas
   pesa unos cientos de bytes, se puede recolorear sin tocar pixeles, y viaja
   entero dentro del JSON del diseno.

   TODOS LOS PATHS ESTAN NORMALIZADOS a una caja de 0..100. Asi el Studio los
   escala a la zona sin factores magicos y el generador de impresion los
   reconstruye con la misma cuenta.

   Se eligen formas que EDISAMP usa de verdad — corazones, estrellas, patas de
   animal, marcos, burbujas — y no un pack generico: cada una tiene que servir
   para una taza, un porte-cle o una camiseta.
   ========================================================================== */

const SYMBOLES = (() => {
'use strict';

/* Cada entrada: id, nombre en frances (lo ve el cliente), familia para
   agrupar, y el path en la caja 0..100. `plein:false` marca las que se dibujan
   como trazo (marcos, flechas) y necesitan grosor en vez de relleno. */
const LISTE = [
  /* ------------------------------- amour ------------------------------- */
  { id:'coeur', nom:'Cœur', famille:'Amour',
    d:'M50 92 C50 92 6 62 6 34 C6 16 19 5 33 5 C41 5 47 10 50 16 '
     +'C53 10 59 5 67 5 C81 5 94 16 94 34 C94 62 50 92 50 92 Z' },
  { id:'coeur-contour', nom:'Cœur fin', famille:'Amour', plein:false,
    d:'M50 88 C50 88 10 60 10 34 C10 18 21 8 33 8 C41 8 47 13 50 19 '
     +'C53 13 59 8 67 8 C79 8 90 18 90 34 C90 60 50 88 50 88 Z' },
  { id:'coeurs-deux', nom:'Deux cœurs', famille:'Amour',
    d:'M34 74 C34 74 4 53 4 34 C4 22 12 14 21 14 C27 14 31 17 34 22 '
     +'C37 17 41 14 47 14 C56 14 64 22 64 34 C64 53 34 74 34 74 Z '
     +'M68 92 C68 92 42 74 42 57 C42 47 49 40 57 40 C62 40 66 43 68 47 '
     +'C70 43 74 40 79 40 C87 40 94 47 94 57 C94 74 68 92 68 92 Z' },

  /* ------------------------------- etoiles ------------------------------ */
  { id:'etoile', nom:'Étoile', famille:'Étoiles',
    d:'M50 4 L62 36 L96 38 L69 59 L79 92 L50 72 L21 92 L31 59 L4 38 L38 36 Z' },
  { id:'etoile-4', nom:'Éclat', famille:'Étoiles',
    d:'M50 2 C54 30 70 46 98 50 C70 54 54 70 50 98 C46 70 30 54 2 50 '
     +'C30 46 46 30 50 2 Z' },
  { id:'etoiles-trois', nom:'Trois étoiles', famille:'Étoiles',
    d:'M28 10 L34 26 L51 27 L38 38 L42 55 L28 45 L14 55 L18 38 L5 27 L22 26 Z '
     +'M74 34 L79 47 L93 48 L82 57 L86 71 L74 63 L62 71 L66 57 L55 48 L69 47 Z '
     +'M43 66 L47 76 L58 77 L49 84 L52 95 L43 89 L34 95 L37 84 L28 77 L39 76 Z' },

  /* ------------------------------ animaux ------------------------------- */
  { id:'patte', nom:'Patte', famille:'Animaux',
    d:'M50 52 C62 52 74 62 74 74 C74 84 66 90 57 88 C53 87 47 87 43 88 '
     +'C34 90 26 84 26 74 C26 62 38 52 50 52 Z '
     +'M22 30 C29 30 34 37 34 45 C34 52 29 57 23 57 C16 57 11 50 11 43 '
     +'C11 35 16 30 22 30 Z '
     +'M78 30 C84 30 89 35 89 43 C89 50 84 57 77 57 C71 57 66 52 66 45 '
     +'C66 37 71 30 78 30 Z '
     +'M40 12 C46 12 50 19 50 27 C50 34 46 39 40 39 C34 39 29 32 29 24 '
     +'C29 17 34 12 40 12 Z '
     +'M60 12 C66 12 71 17 71 24 C71 32 66 39 60 39 C54 39 50 34 50 27 '
     +'C50 19 54 12 60 12 Z' },
  { id:'os', nom:'Os', famille:'Animaux',
    d:'M20 32 C13 32 8 37 8 44 C8 48 10 51 13 53 C10 55 8 58 8 62 '
     +'C8 69 13 74 20 74 C26 74 31 70 32 64 L68 64 C69 70 74 74 80 74 '
     +'C87 74 92 69 92 62 C92 58 90 55 87 53 C90 51 92 48 92 44 '
     +'C92 37 87 32 80 32 C74 32 69 36 68 42 L32 42 C31 36 26 32 20 32 Z' },
  { id:'papillon', nom:'Papillon', famille:'Animaux',
    d:'M50 30 C50 30 40 8 26 8 C12 8 4 20 4 34 C4 48 18 56 34 52 '
     +'C24 60 14 68 14 80 C14 90 22 96 32 94 C42 92 48 78 50 62 '
     +'C52 78 58 92 68 94 C78 96 86 90 86 80 C86 68 76 60 66 52 '
     +'C82 56 96 48 96 34 C96 20 88 8 74 8 C60 8 50 30 50 30 Z' },

  /* ------------------------------- nature ------------------------------- */
  { id:'fleur', nom:'Fleur', famille:'Nature',
    d:'M50 6 C60 6 68 14 68 24 C68 28 67 31 65 34 C68 32 71 31 75 31 '
     +'C85 31 93 39 93 49 C93 59 85 67 75 67 C71 67 68 66 65 64 '
     +'C67 67 68 70 68 74 C68 84 60 92 50 92 C40 92 32 84 32 74 '
     +'C32 70 33 67 35 64 C32 66 29 67 25 67 C15 67 7 59 7 49 '
     +'C7 39 15 31 25 31 C29 31 32 32 35 34 C33 31 32 28 32 24 '
     +'C32 14 40 6 50 6 Z M50 38 C44 38 39 43 39 49 C39 55 44 60 50 60 '
     +'C56 60 61 55 61 49 C61 43 56 38 50 38 Z' },
  { id:'feuille', nom:'Feuille', famille:'Nature',
    d:'M50 4 C22 18 8 40 8 62 C8 80 22 94 40 94 C68 94 92 66 92 24 '
     +'C92 16 91 10 90 6 C78 12 62 10 50 4 Z' },
  { id:'soleil', nom:'Soleil', famille:'Nature',
    d:'M50 28 C62 28 72 38 72 50 C72 62 62 72 50 72 C38 72 28 62 28 50 '
     +'C28 38 38 28 50 28 Z '
     +'M47 2 h6 v14 h-6 Z M47 84 h6 v14 h-6 Z M2 47 h14 v6 H2 Z '
     +'M84 47 h14 v6 H84 Z '
     +'M16 12 l4-4 l10 10 l-4 4 Z M70 66 l4-4 l10 10 l-4 4 Z '
     +'M84 16 l-4-4 l-10 10 l4 4 Z M30 70 l-4-4 l-10 10 l4 4 Z' },

  /* -------------------------------- fete -------------------------------- */
  { id:'couronne', nom:'Couronne', famille:'Fête',
    d:'M10 76 L18 30 L34 48 L50 18 L66 48 L82 30 L90 76 Z '
     +'M10 82 h80 v10 H10 Z' },
  { id:'cadeau', nom:'Cadeau', famille:'Fête',
    d:'M8 44 h84 v12 H8 Z M14 56 h72 v38 H14 Z M44 44 h12 v50 H44 Z '
     +'M50 40 C50 40 38 40 32 34 C27 29 29 20 36 20 C44 20 50 32 50 40 Z '
     +'M50 40 C50 40 62 40 68 34 C73 29 71 20 64 20 C56 20 50 32 50 40 Z' },
  { id:'ballon', nom:'Ballon', famille:'Fête',
    d:'M50 6 C66 6 78 20 78 38 C78 56 64 72 50 76 C36 72 22 56 22 38 '
     +'C22 20 34 6 50 6 Z '
     +'M46 76 h8 l-2 8 h-4 Z '
     +'M50 84 C50 84 58 88 56 94 C55 97 50 96 50 92 C50 96 45 97 44 94 '
     +'C42 88 50 84 50 84 Z' },

  /* ------------------------------- cadres ------------------------------- */
  { id:'cadre-rond', nom:'Cadre rond', famille:'Cadres', plein:false,
    d:'M50 8 A42 42 0 1 1 49.9 8 Z' },
  { id:'cadre-carre', nom:'Cadre carré', famille:'Cadres', plein:false,
    d:'M10 10 h80 v80 h-80 Z' },
  { id:'banniere', nom:'Bannière', famille:'Cadres',
    d:'M6 26 h88 v34 H6 Z M6 26 L18 43 L6 60 Z M94 26 L82 43 L94 60 Z' },
  { id:'bulle', nom:'Bulle', famille:'Cadres',
    d:'M12 12 h76 a8 8 0 0 1 8 8 v44 a8 8 0 0 1 -8 8 H44 L22 92 L26 72 H12 '
     +'a8 8 0 0 1 -8 -8 V20 a8 8 0 0 1 8 -8 Z' },

  /* ------------------------------- divers ------------------------------- */
  { id:'fleche', nom:'Flèche', famille:'Divers',
    d:'M6 40 h56 V22 L96 50 L62 78 V60 H6 Z' },
  { id:'eclair', nom:'Éclair', famille:'Divers',
    d:'M58 4 L20 56 h22 L38 96 L80 40 H56 Z' },
  { id:'note', nom:'Note de musique', famille:'Divers',
    d:'M40 12 L80 4 v14 L40 26 Z M40 12 v58 h-8 V12 Z M80 4 v50 h-8 V4 Z '
     +'M32 58 C40 58 44 64 44 70 C44 78 37 84 29 84 C21 84 16 78 16 72 '
     +'C16 64 24 58 32 58 Z '
     +'M72 42 C80 42 84 48 84 54 C84 62 77 68 69 68 C61 68 56 62 56 56 '
     +'C56 48 64 42 72 42 Z' },

  /* ------------------------- taches (fondos recortados) -----------------
     NO son decoracion: son el FONDO. Franklin, ensenando sus porte-cles ya
     fabricados —una mancha de pintura turquesa, otra azul, otra morada
     detras del nombre—: « no solamente fondo completo, un circular completo,
     simplemente cortados, para que el cliente pueda moverlo ».
     El color de fondo del panel « Fond » pinta la zona ENTERA y no se puede
     ni mover ni recortar; estas se colocan, se escalan y se mandan al fondo
     con el boton del panel. Son las mismas piezas que el ya vende.
     Bordes irregulares a proposito: una mancha de pintura no tiene el
     contorno liso, y en acrilico se nota. */
  { id:'tache-pinceau', nom:'Tache de peinture', famille:'Taches',
    d:'M14 44 C10 32 18 20 30 16 C40 12 48 18 58 15 C70 11 84 16 88 28 '
     +'C92 40 86 46 88 56 C90 68 84 80 72 84 C60 88 52 82 40 85 '
     +'C26 88 16 80 13 68 C10 58 17 54 14 44 Z' },
  { id:'tache-ronde', nom:'Tache ronde', famille:'Taches',
    d:'M50 8 C68 8 80 16 86 30 C92 44 90 58 84 70 C77 84 64 92 50 92 '
     +'C36 92 22 85 15 71 C8 57 8 42 16 29 C24 15 34 8 50 8 Z' },
  { id:'tache-large', nom:'Trait large', famille:'Taches',
    d:'M8 38 C22 30 36 34 50 33 C64 32 78 27 92 34 C96 36 96 44 92 47 '
     +'C78 54 64 50 50 51 C36 52 22 57 9 50 C5 48 4 40 8 38 Z' },
  { id:'tache-nuage', nom:'Nuage', famille:'Taches',
    d:'M26 70 C14 70 6 62 6 52 C6 42 14 34 25 34 C27 22 37 14 49 14 '
     +'C61 14 71 22 74 33 C86 34 94 42 94 52 C94 62 86 70 74 70 Z' },
  { id:'tache-bulle', nom:'Bulle', famille:'Taches',
    d:'M50 10 C74 10 92 24 92 42 C92 60 74 74 50 74 L36 74 L20 90 L24 71 '
     +'C13 64 8 54 8 42 C8 24 26 10 50 10 Z' },
  { id:'tache-goutte', nom:'Goutte', famille:'Taches',
    d:'M50 6 C50 6 84 44 84 62 C84 79 69 92 50 92 C31 92 16 79 16 62 '
     +'C16 44 50 6 50 6 Z' },

  /* --------------------------- formas basicas ---------------------------
     Un circulo, un ovalo y un rombo no son « una forma mas »: son el recorte
     mas pedido para encajar una foto detras de un nombre. Faltaban. */
  { id:'ovale', nom:'Ovale', famille:'Divers',
    d:'M50 10 C74 10 92 28 92 50 C92 72 74 90 50 90 C26 90 8 72 8 50 '
     +'C8 28 26 10 50 10 Z' },
  { id:'losange', nom:'Losange', famille:'Divers',
    d:'M50 6 L94 50 L50 94 L6 50 Z' },
  { id:'hexagone-f', nom:'Hexagone', famille:'Divers',
    d:'M50 6 L92 28 L92 72 L50 94 L8 72 L8 28 Z' },
  { id:'triangle', nom:'Triangle', famille:'Divers',
    d:'M50 8 L92 86 L8 86 Z' },

  /* ------------------------------- amour -------------------------------- */
  { id:'coeur-fleche', nom:'Cœur percé', famille:'Amour',
    d:'M50 88 C50 88 10 60 10 34 C10 18 21 8 33 8 C41 8 47 13 50 19 '
     +'C53 13 59 8 67 8 C79 8 90 18 90 34 C90 60 50 88 50 88 Z '
     +'M4 20 L96 66 L92 74 L0 28 Z' },
  { id:'bague', nom:'Alliance', famille:'Amour',
    d:'M50 24 C70 24 86 40 86 58 C86 76 70 92 50 92 C30 92 14 76 14 58 '
     +'C14 40 30 24 50 24 Z M50 38 C38 38 28 47 28 58 C28 69 38 78 50 78 '
     +'C62 78 72 69 72 58 C72 47 62 38 50 38 Z M50 4 L62 20 L38 20 Z' },

  /* ------------------------------ etoiles ------------------------------- */
  { id:'etoile-six', nom:'Étoile à six', famille:'Étoiles',
    d:'M50 4 L63 30 L92 30 L69 48 L78 76 L50 60 L22 76 L31 48 L8 30 L37 30 Z' },
  { id:'lune', nom:'Lune', famille:'Étoiles',
    d:'M64 6 C40 12 24 30 24 52 C24 74 40 90 62 94 C40 98 10 82 10 52 '
     +'C10 22 38 4 64 6 Z' },
  { id:'soleil-rayons', nom:'Soleil', famille:'Étoiles',
    d:'M50 26 C63 26 74 37 74 50 C74 63 63 74 50 74 C37 74 26 63 26 50 '
     +'C26 37 37 26 50 26 Z M46 0 H54 V16 H46 Z M46 84 H54 V100 H46 Z '
     +'M0 46 H16 V54 H0 Z M84 46 H100 V54 H84 Z' },

  /* ------------------------------ animaux ------------------------------- */
  { id:'chat', nom:'Chat', famille:'Animaux',
    d:'M18 34 L14 8 L36 22 C45 19 55 19 64 22 L86 8 L82 34 '
     +'C90 44 92 56 88 66 C82 82 67 92 50 92 C33 92 18 82 12 66 '
     +'C8 56 10 44 18 34 Z' },
  { id:'papillon', nom:'Papillon', famille:'Animaux',
    d:'M50 30 C44 14 28 6 18 12 C6 19 6 38 18 46 C6 54 6 73 18 80 '
     +'C28 86 44 78 50 62 C56 78 72 86 82 80 C94 73 94 54 82 46 '
     +'C94 38 94 19 82 12 C72 6 56 14 50 30 Z' },
  { id:'oiseau', nom:'Oiseau', famille:'Animaux',
    d:'M6 56 C22 50 32 40 44 26 C52 16 66 12 76 18 L92 14 L84 28 '
     +'C88 44 80 62 64 72 C48 82 26 82 8 72 C16 70 22 66 26 62 '
     +'C18 62 10 60 6 56 Z' },

  /* ------------------------------- nature ------------------------------- */
  { id:'arbre', nom:'Arbre', famille:'Nature',
    d:'M50 4 L74 34 H62 L82 62 H58 V94 H42 V62 H18 L38 34 H26 Z' },
  { id:'feuille-double', nom:'Branche', famille:'Nature',
    d:'M50 94 V20 M50 44 C34 44 22 34 20 18 C38 18 48 28 50 44 Z '
     +'M50 60 C66 60 78 50 80 34 C62 34 52 44 50 60 Z' },
  { id:'montagne', nom:'Montagne', famille:'Nature',
    d:'M4 84 L32 32 L48 60 L62 38 L96 84 Z' },

  /* -------------------------------- fete -------------------------------- */
  { id:'gateau', nom:'Gâteau', famille:'Fête',
    d:'M48 6 C52 12 56 14 56 20 C56 24 53 27 49 27 C45 27 42 24 42 20 '
     +'C42 14 46 12 48 6 Z M22 34 H76 V52 H22 Z M12 58 H86 V90 H12 Z' },
  { id:'ballons', nom:'Ballons', famille:'Fête',
    d:'M32 6 C44 6 52 16 52 28 C52 40 44 50 32 50 C20 50 12 40 12 28 '
     +'C12 16 20 6 32 6 Z M32 50 L36 96 M70 22 C80 22 87 30 87 40 '
     +'C87 50 80 58 70 58 C60 58 53 50 53 40 C53 30 60 22 70 22 Z '
     +'M70 58 L66 96' },
  { id:'confetti', nom:'Confettis', famille:'Fête',
    d:'M14 12 L24 22 L14 32 L4 22 Z M52 6 L60 14 L52 22 L44 14 Z '
     +'M86 20 L96 30 L86 40 L76 30 Z M26 52 L34 60 L26 68 L18 60 Z '
     +'M62 46 L72 56 L62 66 L52 56 Z M12 74 L22 84 L12 94 L2 84 Z '
     +'M50 78 L58 86 L50 94 L42 86 Z M84 62 L94 72 L84 82 L74 72 Z' },

  /* ------------------------------- cadres ------------------------------- */
  { id:'cadre-rond', nom:'Cercle fin', famille:'Cadres', plein:false,
    d:'M50 8 C73 8 92 27 92 50 C92 73 73 92 50 92 C27 92 8 73 8 50 '
     +'C8 27 27 8 50 8 Z' },
  { id:'cadre-feston', nom:'Cadre festonné', famille:'Cadres', plein:false,
    d:'M50 10 C58 4 68 8 70 17 C79 15 87 22 85 31 C93 35 94 46 87 51 '
     +'C93 57 90 68 81 70 C81 79 72 85 64 82 C61 91 50 94 44 87 '
     +'C37 93 27 89 25 80 C16 81 9 73 11 64 C3 60 2 49 9 44 '
     +'C3 38 6 27 15 25 C15 16 24 10 32 13 C35 4 46 3 50 10 Z' },
  { id:'ruban', nom:'Ruban', famille:'Cadres',
    d:'M6 30 H94 V54 H6 Z M6 30 L18 42 L6 54 Z M94 30 L82 42 L94 54 Z' },

  /* ------------------------------- divers ------------------------------- */
  { id:'cle', nom:'Clé', famille:'Divers',
    d:'M30 10 C43 10 54 21 54 34 C54 44 48 52 40 56 V78 H52 V88 H40 V96 '
     +'H26 V56 C18 52 12 44 12 34 C12 21 17 10 30 10 Z '
     +'M30 24 C25 24 21 28 21 33 C21 38 25 42 30 42 C35 42 39 38 39 33 '
     +'C39 28 35 24 30 24 Z' },
  { id:'maison', nom:'Maison', famille:'Divers',
    d:'M50 8 L94 46 H80 V92 H58 V64 H42 V92 H20 V46 H6 Z' },
  { id:'avion', nom:'Avion', famille:'Divers',
    d:'M96 44 L58 50 L38 92 H28 L36 48 L10 52 L2 40 L36 32 L52 4 H62 '
     +'L56 30 L94 34 Z' },
  { id:'tasse', nom:'Tasse', famille:'Divers',
    d:'M14 26 H74 V64 C74 76 64 86 52 86 H36 C24 86 14 76 14 64 Z '
     +'M74 36 H84 C90 36 94 41 94 47 C94 55 88 60 80 60 H74 Z' },
];

const FAMILLES = [...new Set(LISTE.map(s => s.famille))];
const parId = id => LISTE.find(s => s.id === id) || null;

/* Miniatura SVG para el panel. Se dibuja el mismo path, asi que lo que el
   cliente ve en la lista es exactamente lo que va a colocar. */
/* EL COLOR DE LA MINIATURA NO ES EL DEL PRODUCTO. Se pasaba el primer color
   de la ficha, y en el porte-cles ese color es el BLANCO: el panel entero se
   quedaba en blanco sobre blanco. Franklin: « en la columna de formas no se
   ve; tienen que estar en negro, asi para ser mas claros ».
   La miniatura es un boton de un catalogo, no una vista previa del resultado:
   lo que tiene que hacer es LEERSE. El color elegido se ve en la pieza en
   cuanto se coloca, y en las pastillas de color justo debajo. */
function apercuSVG(s, couleur) {
  const c = couleur || '#1A1A1A';
  const trait = s.plein === false
    ? `fill="none" stroke="${c}" stroke-width="7" stroke-linejoin="round"`
    : `fill="${c}"`;
  return `<svg viewBox="-4 -4 108 108" xmlns="http://www.w3.org/2000/svg">`
       + `<path d="${s.d}" ${trait}/></svg>`;
}

return { LISTE, FAMILLES, parId, apercuSVG };
})();
